import { useFlag } from '@unleash/proxy-client-react';
import useAuth from 'hooks/useAuth';
import { canInterrogateWatch } from 'utils/authorization';

/** The HMI is reachable only behind the flag and for users the `/hmi` proxy will accept. */
export const useIsHmiAvailable = (): boolean => {
  const isHmiEnabled = useFlag('hmi-gui');
  const { user } = useAuth();

  return isHmiEnabled && canInterrogateWatch(user?.role);
};
